﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as React from "react";
import type { RegisterPageCustomizations } from "~base/Pages/Account/Register";
import { RegisterPageDefaultCustomization } from "~base/Pages/Account/Register";
import SoPLogo from "~irad-resources/Logos/SoPLogoMask.svg?url";

//-------------------------------------------------------------------------------------
// Exports
//-------------------------------------------------------------------------------------

const customStyling = {
    header: {
        padding: "25px 33px 0px 8px",
    },
};

export default {
    ...RegisterPageDefaultCustomization,
    showEmail: false,
    showPhoneNumber: false,
    showArbetarMedDistansrådgivning: false,
    showRådgivarkod: false,
    showVerksamhetsort: false,
    customStyles: customStyling,
    userInfoCustomization: {
        pictureFrame: (
            <img
                src={SoPLogo}
                style={{
                    width: "50px",
                    paddingTop: "5px",
                }}
            />
        ),
    },
} as RegisterPageCustomizations;
